import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ws-start-next/ws-start-next/components/PageLayout/MainLayoutV2.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ws-start-next/ws-start-next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ws-start-next/ws-start-next/providers/ApplicationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ws-start-next/ws-start-next/styles/global.css");
